module.exports = __webpack_public_path__ + "static/pam-a-casa-1203466c79f49764c1f5661a090ad220.jpg";